import _ from 'lodash';
import {
  StyledIntegrationStatsChart,
  StyledStatsChartWrapper
} from './IntegrationStatsChart.style';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import Tooltip from '@material-ui/core/Tooltip';
import { getColor } from 'common/constants/_colors';
import { LineSkeleton as LineLoader } from 'components/base/Skeletons';

const IntegrationStatsChart = ({ stats, isLoading }) => {
  const statsValues = _.values(stats);

  const isEmptyValues = _.every(statsValues, value => value === 0);

  const TooltipTitle = isEmptyValues
    ? 'No activity in the past 15 days'
    : 'Integration activity in the past 15 days';

  return (
    <Tooltip title={TooltipTitle} placement='top'>
      <StyledIntegrationStatsChart>
        <StyledStatsChartWrapper>
          {isLoading ? (
            <LineLoader size={90} />
          ) : (
            <ResponsiveContainer
              width='100%'
              height={isEmptyValues ? '40%' : '80%'}
            >
              <LineChart width='100%' height='100%' data={statsValues}>
                <Line
                  type='monotone'
                  stroke={getColor('chambray')}
                  strokeWidth={2}
                  dot={false}
                  dataKey={stat => stat}
                  {...(isEmptyValues ? { strokeDasharray: '3 4' } : {})}
                />
              </LineChart>
            </ResponsiveContainer>
          )}
        </StyledStatsChartWrapper>
      </StyledIntegrationStatsChart>
    </Tooltip>
  );
};

export default IntegrationStatsChart;
